import { render } from "./IFrameModal.vue?vue&type=template&id=74da98d9&scoped=true"
import script from "./IFrameModal.vue?vue&type=script&lang=js"
export * from "./IFrameModal.vue?vue&type=script&lang=js"

import "./IFrameModal.vue?vue&type=style&index=0&id=74da98d9&lang=css"
import "./IFrameModal.vue?vue&type=style&index=1&id=74da98d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74da98d9"]])

export default __exports__